var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getClients)?_c('div',{staticClass:"panel-body"},[_c('form',[_c('vue-form-generator',{ref:"form",attrs:{"schema":_vm.schema,"model":_vm.model,"options":_vm.formOptions},on:{"validated":_vm.onValidated}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }